<template>
  <v-dialog
    v-model="dialog"
    width="500"
  >
    <v-card
      class="mx-auto"
    >
      <v-toolbar
        color="primary"
        dark
      >
        <v-toolbar-title>
          <v-icon color="tertiary">person</v-icon>
          Usuario: {{ user.primer_nombre }}
        </v-toolbar-title>
      </v-toolbar>

      <v-card-text>
        <h3>
          Primer Nombre: {{ user.primer_nombre }} <br>
          Segundo Nombre: {{ user.segundo_nombre }} <br>
          Primer Apellido: {{ user.primer_apellido }} <br>
          Segundo Apellido: {{ user.segundo_apellido }} <br>
          Fecha de Nacimiento: {{ user.fecha_nacimiento }} <br>
          Factor RH: {{ user.rh }} <br>
          Sexo: {{ user.genero }} <br>
          Cedula: {{ user.cedula }} <br>
          Telefono: {{ user.telefono }}
        </h3>
      </v-card-text>

      <v-divider/>

      <!-- <v-layout
        tag="v-card-text"
        text-xs-left
        wrap
      >
        <v-flex tag="strong" xs5 text-xs-right mr-3 mb-2>Primer Nombre:</v-flex>
        <v-flex>{{ user.primer_nombre }}</v-flex>
        <v-flex tag="strong" xs5 text-xs-right mr-3 mb-2>Segundo Nombre:</v-flex>
        <v-flex>{{ user.segundo_nombre }}</v-flex>

        <v-flex tag="strong" xs5 text-xs-right mr-3 mb-2>Primer Apellido:</v-flex>
        <v-flex>{{ user.primer_apellido }}</v-flex>
        <v-flex tag="strong" xs5 text-xs-right mr-3 mb-2>Segundo Apellido:</v-flex>
        <v-flex>{{ user.segundo_apellido }}</v-flex>

        <v-flex tag="strong" xs5 text-xs-right mr-3 mb-2>Fecha de Nacimiento:</v-flex>
        <v-flex>{{ user.fecha_nacimiento }}</v-flex>
        <v-flex tag="strong" xs5 text-xs-right mr-3 mb-2>RH:</v-flex>
        <v-flex>{{ user.rh }}</v-flex>
        <v-flex tag="strong" xs5 text-xs-right mr-3 mb-2>Sexo:</v-flex>
        <v-flex>{{ user.genero }}</v-flex>
        <v-flex tag="strong" xs5 text-xs-right mr-3 mb-2>Cedula:</v-flex>
        <v-flex>{{ user.cedula }}</v-flex>
        <v-flex tag="strong" xs5 text-xs-right mr-3 mb-2>Telefono:</v-flex>
        <v-flex>{{ user.telefono }}</v-flex>
      </v-layout>

      <v-divider/> -->

      <v-card-actions>
        <v-flex class="text-xs-right">
          <v-btn
            color="info"
            text
            @click="dialog = false"
          >
            Continuar
          </v-btn>
        </v-flex>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: 'Usuario',

  created () {
    this.user = this.$store.state.user
  },

  props: {
    /**
     * Activador del dialog
     */
    dialog: {
      type: Boolean,
      required: true
    }
  },

  data: function () {
    return {
      user: null
    }
  }
}
</script>
